export default function selectGitHubNodesById(state) {
  return state.integrations.thirdPartyData.github.nodes
}
